import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';

@Injectable()
export class OauthService {

  oauthURL = 'authorization-service/';

  constructor(private httpClient: HttpClient) { }

  public aoutUser(): Observable<any> {
    const url = this.oauthURL + 'authorization/roles';
    return this.httpClient.get<any>(url, {}).pipe(
      catchError(e => {
        const message = e?.error?.message ?? e?.message ?? (e?.status ? `HTTP ${e.status}` : 'Unknown error');
        console.error(message);
        return throwError(() => new Error(message));
      })
    );
  }
}
